import React, { createContext, useEffect, useState } from 'react';

import { NavContextType, NavItemType } from '../types/types';

export const NavContext = createContext<NavContextType | null>(null);

export const NavProvider: React.FC<{
  children: React.ReactNode;
  navItems: { items: NavItemType[] };
  initialDrawerOpen?: boolean;
  initialOpenItem?: string[];
}> = ({
  children,
  navItems,
  initialDrawerOpen = true,
  initialOpenItem = ['dashboard'],
}) => {
  const [openItem, setOpenItem] = useState(initialOpenItem);
  const [nav, setNav] = useState(navItems);
  const [selectedID, setSelectedID] = useState<string | null | number>(null);
  const [drawerOpen, setDrawerOpen] = useState(initialDrawerOpen);
  const [fluid, setFluid] = useState(false);

  useEffect(() => {
    setNav(navItems);
  }, [navItems]);

  return (
    <NavContext.Provider
      value={{
        drawerOpen,
        nav,
        fluid,
        openItem,
        selectedID,
        setDrawerOpen,
        setFluid,
        setNav,
        setOpenItem,
        setSelectedID,
      }}
    >
      {children}
    </NavContext.Provider>
  );
};
